import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Divider } from 'components/RouteMatchSidebarNavContainer/components/Divider';
import { QuickHelpButton } from 'components/RouteMatchSidebarNavContainer/routeMatchSidebarSharedComps';

import { ProcessStepperV1 } from '../ProcessStepperV1';

const ReviewProcessSidebar = () => (
  <Flex flexDir="column" height="100%" position="relative">
    <Flex flexGrow={1} flexDir="column" overflowY="auto">
      <ProcessStepperV1 />
    </Flex>
    <Box px={3}>
      <Divider color="border.CFD7DF" />
      <QuickHelpButton />
    </Box>
  </Flex>
);

export { ReviewProcessSidebar };
